import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import FileUploadIcon from '@mui/icons-material/CloudUpload';
import { Box } from '@mui/material';

const s:any = {
  container: {
    display: 'flex',
    justifyContent:'flex-start',
    alignItems: 'center'
  },
  preview: {
    width:200,
    height: 40,
    mt: 1,
    ml: 1,
    mr: 1,
  },
  button: {
    m: 1
  },
  input: {
    display: 'none',
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'flex'
  }
};

class FFileField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      source: undefined
    };
  }

  onChange = (event:any) => {
    event.persist();
    let that = this;
    let file:any, fr:any;
    let files:any = event.target.files || event.dataTransfer.files;
    if(files) {
      file = files[0];
      fr = new FileReader();
      fr.onload = function createImage() {
        that.setState({source:fr.result});
        if(that.props.onChange) that.props.onChange(event.target.name)(event,file);
        //console.log('source set, onChange called');
      };
      fr.readAsDataURL(file);
    }
  }

  render() {
    const {id,name,children,preview,previewStyle,divider,classes} = this.props;
    const {source} = this.state;
    //var accept = "image/*";
    return (
      <Box>
      <Box sx={{...s.container}}>
        <Box component="input"
          //accept={accept}
          sx={{...s.input}}
          id={id}
          name={name}
          type="file"
          onChange={this.onChange}
        />
        <label htmlFor={id}>
          <Button variant="contained" component="span" sx={{...s.button}}>
            <FileUploadIcon color={'inherit'}/>
            {children}
          </Button>
        </label>
        {preview&&<img className={source?classes.preview:classes.hidden} style={previewStyle||{}} src={source} alt={""}/>}
      </Box>
      {divider && <Divider />}
      </Box>
    );
  }
}

FFileField.propTypes = {
  //classes: PropTypes.object.isRequired,
  //children: PropTypes.any.isRequired,
  //label: PropTypes.string.isRequired,
};

export default FFileField;
